module.exports = __webpack_public_path__ + "img/detail.8bbf662f.png";